import { whatsappLink } from '@/lib/site-data'
import {MessageCircleDashed as MessageCircle} from 'lucide-react'

interface CtaSectionProps {
  title: string
  description: string
  message: string
  buttonLabel?: string
  tone?: 'light' | 'dark'
}

function CtaSection({ title, description, message, buttonLabel = 'Falar no WhatsApp agora', tone = 'dark' }: CtaSectionProps) {
  const isDark = tone === 'dark'

  return (
    <section className={isDark ? 'bg-[#0B0919]' : 'bg-white'}>
      <div className="mx-auto max-w-4xl px-6 py-16 text-center sm:py-20">
        <h2 className={`text-2xl font-bold sm:text-3xl ${isDark ? 'text-white' : 'text-zinc-900'}`}>
          {title}
        </h2>
        <p className={`mx-auto mt-3 max-w-xl text-base ${isDark ? 'text-zinc-400' : 'text-zinc-600'}`}>
          {description}
        </p>
        <a
          href={whatsappLink(message)}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white shadow-lg shadow-[#25D366]/20 transition-transform hover:scale-105"
        >
          <MessageCircle className="h-5 w-5" fill="white" strokeWidth={0} />
          {buttonLabel}
        </a>
      </div>
    </section>
  )
}

export default CtaSection
